import type {
  FeatureBillingMode,
  OrganizationFeatureEntitlement,
  OrganizationFeatureKey,
} from '@/types/database.types';

export const SHIFT_CSV_IMPORTS_FEATURE = 'shift_csv_imports' satisfies OrganizationFeatureKey;
export const CUSTOM_REPORTS_FEATURE = 'custom_reports' satisfies OrganizationFeatureKey;
export const TEST_ORGANIZATION_ID = '33162baa-e16d-4cb0-a2d7-0a97ab6e66a8';

export const FEATURE_LABELS: Record<OrganizationFeatureKey, string> = {
  shift_csv_imports: 'CSV Shift Imports',
  custom_reports: 'Custom Reports',
};

export const FEATURE_DESCRIPTIONS: Record<OrganizationFeatureKey, string> = {
  shift_csv_imports:
    'Upload CSV files to create one-off shifts, recurring shifts, and employee assignments in bulk.',
  custom_reports:
    'Organisation-specific reports prepared and enabled as paid reporting add-ons.',
};

export const FEATURE_BILLING_MODE_LABELS: Record<FeatureBillingMode, string> = {
  manual: 'Manual',
  paid_addon: 'Paid add-on',
  promo: 'Promo',
  internal_test: 'Internal test',
};

export function isEntitlementActive(
  entitlement: Pick<OrganizationFeatureEntitlement, 'enabled' | 'expires_at'> | null | undefined,
  now = new Date(),
): boolean {
  if (!entitlement?.enabled) return false;
  if (!entitlement.expires_at) return true;
  return new Date(entitlement.expires_at).getTime() > now.getTime();
}
